import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import { getDdbConnections } from "./action";
import { connect } from "react-redux";
import Call from "../../../hocs/call";
import DdbConnectionList from "./List";

const mapStateToProps = state => ({
    connections: state.scenes.mappingHandler.ddbConnection.shared.connections,
    username: state.app.user.username,
    token: state.app.user.token,
    permissions: state.app.user.permissions,
    email: state.app.user.email,
    savedSuccessfully: state.scenes.mappingHandler.ddbConnection.shared.savedSuccessfully,
    hasStartedSaving: state.scenes.mappingHandler.ddbConnection.shared.hasStartedSaving
})

const mapDispatchToProps = dispatch => ({
    onGetDdbConnection: ({username, permissions, token, email}) => dispatch(getDdbConnections(
      {
        username, 
        permissions, 
        token,
        email,
        metadataFlow: [], 
        dataflow: [],
        isAuthenticated: true,
        dbbConnections: [],
      })),
})

const DdbConnection = ({
                          t,
                          connections,
                          onGetDdbConnection,
                          username,
                          permissions,
                          email,
                          token,
                          savedSuccessfully,
                          hasStartedSaving
                      }) => {
    return (
            <Call cb={onGetDdbConnection} cbParam={{username, permissions, token, email}} disabled={(!!connections && !savedSuccessfully && !hasStartedSaving) || (!!connections && !savedSuccessfully && hasStartedSaving)}>
              <DdbConnectionList />
            </Call>
    )

}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(DdbConnection);